import {linearGradientDef} from "@nivo/core";
import {toRGB} from "../../utils/colorUtils";


const DEFAULT_GRADIENT_STEP = 10;

const fontFamily = "Inter, sans-serif";

export const NivoTextTheme = {
  axis: {
      ticks: {
        text: {
          fontSize: 13,
          fontWeight: '400',
          fontFamily
        }
      }
    },
    labels: {
      text: {
        textAnchor: 'middle',
        fontSize: 11,
        fontWeight: '400',
        fontFamily,
        dominantBaseline: 'central',

      }
    },
    legends: {
      text: {
          fontWeight: '400',
          fontFamily,
          fontSize: 13
      },
  },
}



export const modernFintechPalette = [
   '#287CF6', // Sky blue
  '#22577E',
  '#00B4D8', // Light sky blue
  '#6C5B7B',
  '#355E3B',
  '#911F27',
   '#566D7E',  // Slate gray
   '#48788B',  // Steel blue
   '#404E4D',  // Charcoal
   '#1D3C45',  // Deep navy
   '#009688',  // Teal
   '#283533',  //  Very dark gray
   '#33414E'  //  Dark muted green
];


// Generate gradient definitions dynamically based on schemeCategory10
export const adjustColor = (color, amount) => {
  let colorNum = parseInt(color.slice(1), 16);
  let r = (colorNum >> 16) + amount;
  let g = (colorNum & 0x0000FF) + amount;
  let b = ((colorNum >> 8) & 0x00FF) + amount;

  r = Math.max(Math.min(255, r), 0);
  g = Math.max(Math.min(255, g), 0);
  b = Math.max(Math.min(255, b), 0);

  return `#${(r << 16 | b << 8 | g).toString(16).padStart(6, '0')}`;
};

// Generate gradient definitions dynamically based on schemeCategory10
export const generateGradients = (keys, customColors=null, gradientStep=DEFAULT_GRADIENT_STEP,
                                  opacity=1) => {
  return keys.map((key, index) => {
      let baseColor = customColors?.[key];
      if (!baseColor){
          baseColor = modernFintechPalette[index % modernFintechPalette.length];
      }
    const lighterColor = adjustColor(baseColor, gradientStep); // Create a lighter version
    const darkerColor = adjustColor(baseColor, -gradientStep); // Create a darker version
    return linearGradientDef(`gradient${index}`, [
      { offset: 0, color: lighterColor, opacity },
        { offset: 100, color: darkerColor, opacity },

    ]);
  });
};


export const generateGradientsAndColors = (keys, customColors=null, gradientStep=DEFAULT_GRADIENT_STEP,
                                           opacity=1) => {
  const gradients = [];
  const colorMapping = {};

  keys.forEach((key, index) => {
    let baseColor = customColors?.[key];
    if (!baseColor){
        baseColor = modernFintechPalette[index % modernFintechPalette.length];
    }
    const lighterColor = adjustColor(baseColor, gradientStep);
    const darkerColor = adjustColor(baseColor, -gradientStep);
    gradients.push(linearGradientDef(`gradient${index}`, [
      { offset: 0, color: lighterColor, opacity },
        { offset: 100, color: darkerColor, opacity },

    ]));
    colorMapping[key] = baseColor;
  });

  return { gradients, colorMapping };
};

// Apply the gradients to bars based on their key
export const applyGradients = (keys) => {
  return keys.map(key => ({
    match: { id: key },
    id: `gradient${keys.indexOf(key)}`,
    attrs: {
        fill: '',
    }
  }));
};


export const formatLabel = (d, precision, postfix) => `${d?.value?.toFixed?.(precision)}${postfix ?? ''}`;

